<div class="overflow-x-auto invisible-scroll">
    <dl
        class="key-metrics row gy-0 gy-lg-4 justify-content-start justify-content-lg-evenly flex-nowrap flex-lg-column justify-content-xl-end flex-xl-wrap flex-xl-row"
    >
        <section
            class="col-auto col-xl-6"
            *ngFor="let metric of metrics$ | async; trackBy: metricLabel"
        >
            <dt [attr.data-cy]="'metric-' + metric.label">{{ metric.label }}</dt>
            <dd
                [attr.data-cy]="'metric-value-' + metric.label"
                *ngIf="metric.format !== false"
                class="metric"
                [class.metric-animated]="metric.format !== false && cssPropertySupport"
                [class]="'metric-' + metric.type"
                [style]="metric.style"
            >
                <span
                    *ngIf="
                        (metric.type === 'number' || metric.type === 'integer') &&
                        metric.ccy
                    "
                    [matTooltip]="
                        metric.value | formatCurrency$: metric.ccy:metric.format | async
                    "
                    matTooltipPosition="above"
                >
                    {{ metric.value | formatCurrency$: metric.ccy:metric.format | async }}
                </span>
                <span
                    *ngIf="
                        (metric.type === 'number' || metric.type === 'integer') &&
                        !metric.ccy
                    "
                    [matTooltip]="metric.value | formattedNumber$ | async"
                    matTooltipPosition="above"
                >
                    {{ metric.value | formattedNumber$ | async }}
                </span>
                <span
                    *ngIf="metric.type === 'percent'"
                    [matTooltip]="metric.value | formattedPercent$ | async"
                    matTooltipPosition="above"
                >
                    {{ metric.value | formattedPercent$ | async }}
                </span>
            </dd>
            <dd *ngIf="metric.format === false" class="metric">{{ metric.value }}</dd>
        </section>
    </dl>
</div>
